unable to read source [project]/momira.app/web/node_modules/src/ui/scanner/camera-selection-ui.ts